import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useSystemStatus = (config) => {
  return useQuery({
    ...config,
    queryKey: "system-status",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/system-status`,
        withHeaders: true,
        signal,
      }),
    select: (response) => {
      if (response._parsedBody && response._headers) {
        return {
          ...response._parsedBody,
          headers: response._headers,
        };
      }
      return {};
    },
  });
};

export const useCheckForUpdates = (config) => {
  return useQuery({
    ...config,
    queryKey: ["check-for-updates"],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/system-status/check-for-updates`,
        signal,
      }),
  });
};
